// src/client/pages/ChangePasswordClient.jsx
import React, { useState } from 'react';
import { useAuthClient } from '../../core/context/AuthClientContext';
import api from '../../core/api';

const ChangePasswordClient = () => {
  const [formData, setFormData] = useState({ oldPassword: '', newPassword: '' });
  const [message, setMessage] = useState('');
  const { getToken } = useAuthClient();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const clientKey = localStorage.getItem('selectedClient') || 'le_resto_local';

      await api.put(
        `/api/users/change-password`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            'x-client-key': clientKey,
          },
        }
      );

      setMessage('✅ Mot de passe mis à jour.');
    } catch (err) {
      console.error('❌ Erreur changement mot de passe :', err.response?.data || err.message);
      setMessage('❌ Erreur : ' + (err.response?.data?.message || 'Échec.'));
    }
  };

  return (
    <div className="account-container">
      <h2>Changer le mot de passe</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="password"
          name="oldPassword"
          placeholder="Ancien mot de passe"
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="newPassword"
          placeholder="Nouveau mot de passe"
          onChange={handleChange}
          required
        />
        <button type="submit">Mettre à jour</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ChangePasswordClient;
